import { GET_LENDER_ACTIVITY_SUMMARY } from './getLenderActivitySummary';
import { GET_LENDER_ACTIVITY_BY_COUNTRY } from './getLenderActivityByCountry';
import { GET_LENDER_ACTIVITY_BY_LENDER } from './getLenderActivityByLender';
import { GET_LENDER_ACTIVITY_BY_STATE } from './getLenderActivityByState';
import { GET_LENDER_ACTIVITY_BY_DEALER } from './getLenderActivityByDealer';
import { GET_LENDER_ACTIVITY_BY_DECLINE_REASON } from './getLenderActivityByDeclineReason';

export const lenderActivityDashboardApi = {
  getSummary: GET_LENDER_ACTIVITY_SUMMARY,
  getByCountry: GET_LENDER_ACTIVITY_BY_COUNTRY,
  getByLender: GET_LENDER_ACTIVITY_BY_LENDER,
  getByState: GET_LENDER_ACTIVITY_BY_STATE,
  getByDealer: GET_LENDER_ACTIVITY_BY_DEALER,
  getByDeclineReason: GET_LENDER_ACTIVITY_BY_DECLINE_REASON,
};
